<template>
  <div class="we-search-wrap">
    <input
      ref="searchbox"
      :value="currentValue"
      :placeholder="placeholder"
      type="text"
      style="width:100%"
      @input="$emit('input', $event.target.value)"
      @blur="$emit('on-blur', $event.target.value)"
    >
  </div>
</template>
<script>
export default {
  name: "WeSearchBox",
  props: {
    value: String,
    placeholder: {
      type: String,
      default: "搜索……",
    },
  },
  data() {
    return {
      currentValue: this.value,
    };
  },
  watch: {
    value(val) {
      this.currentValue = val;
    },
  },
  methods: {
    onfocus() {
      this.$refs.searchbox.focus();
    },
  },
};
</script>
